export default __webpack_public_path__ + "media/images/react_icons/property/washing_machine-da50e40f1b664da49b2280635340e90d.svg";